let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4VBdX")).then(() => parcelRequire('1u2wJ'));